// Sample configuration for a survey with all possible configuration options.

const surveyConfig = {
	type: 'betaticket',   	// Type name of survey, alphanumeric with underscores
	mode: 'tabbed',			// Mode of survey, single/tabbed. TODO: Only tabbed is implemented for now.
	cols: 1,				// Number of columns in the form root or tabbed roots.
	title: "Want your dream job to find YOU?",
    disableHeaderImage: false,
    linkHeaderImage: null,
	tabs: [
		{ key: 'questions', title: 'Questions' },
	],
	intro: { 
		label: "Introduction",
		title: "Want your dream job to find YOU?",
        containerStyles: "border: none;",
        descriptionRaw: "<div style='font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif; line-height: 1.6; color: #333;'>" +
            "<p style='margin: 0 0 24px 0; font-size: 16px;'>Beta tickets are now available. <strong style='color: #e74c3c;'>But only for a few.</strong></p>" +
            "<div style='background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 20px; border-radius: 8px; margin: 0 0 24px 0; text-align: center;'>" +
            "<h2 style='margin: 0 0 8px 0; font-size: 20px; font-weight: 600;'>🎯 YOUR 2-STEP JOURNEY STARTS HERE 🎯</h2>" +
            "</div>" +
            "<div style='display: flex; gap: 20px; margin: 0 0 24px 0;'>" +
            "<div style='flex: 1; background: #f8f9fa; padding: 20px; border-radius: 8px; border-left: 4px solid #3498db;'>" +
            "<h3 style='margin: 0 0 12px 0; font-size: 18px; color: #2c3e50;'>🧭 Step 1: Tell your story</h3>" +
            "<p style='margin: 0; font-size: 14px; color: #555;'>Complete your profile once. Let us highlight your strengths, goals, and preferences.</p>" +
            "</div>" +
            "<div style='flex: 1; background: #f8f9fa; padding: 20px; border-radius: 8px; border-left: 4px solid #27ae60;'>" +
            "<h3 style='margin: 0 0 12px 0; font-size: 18px; color: #2c3e50;'>🤝 Step 2: Let the Job Match come to you</h3>" +
            "<p style='margin: 0; font-size: 14px; color: #555;'>Sit back and see smart, personalized matches appear.</p>" +
            "</div>" +
            "</div>" +
            "<div style='background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 6px; padding: 16px; margin: 0 0 24px 0;'>" +
            "<p style='margin: 0; font-size: 14px; color: #856404;'><strong>Exclusive Invitation:</strong> We are inviting only a select group of Filipino nurses to help us shape COLPUNO before the full launch.</p>" +
            "</div>" +
            "</div>",
        nextBtnText: "YES! I Want my free Beta Ticket",
        nextBtnHighlight: true,
	},
	conclusion: {
        showInviter: false,
		label: "Submit",
		title: "One last thing...",
		description: "We need your agreement to use your information in accordance with our Privacy Policy.",
        privacy_custom: "/privacy_consent_v2.html",
        privacy_extras: "Your data will only be used to follow up for your entry into COLPUNO, and will not be shared or sold to unrelated third parties.",
	},
    finished: {
        tick: true,
        title: "Thanks for joining COLPUNO!",
        description: "You'll receive an email at the start of August to access your personalized dashboard and get your job matches."
    },
};

// Note: We only support groups in the top level form, and everything MUST be in a group.
// This is because devextreme does not support using simpleitems/groupitems in sub-components of Vue. (See: https://supportcenter.devexpress.com/ticket/details/t1045156/form-dxsimpleitem-into-custom-component)
// This makes it impossible to use a custom component and allow recursive items/inputs, etc.
const surveyFields = [];

import countries from '@/data/countries.js';
let locationCountries = countries.filter(c => c.code != 'PH').map(c => c.code + '|' + c.name);

// Tab 1
surveyFields.push({ key: 'questions', tab: 'questions', type: 'group', label: "Your career profile", cols:2, items: [
    { key: 'looking_for_job', type: 'select', label: "Are you looking for a new job?", required: true, options: [ 'yes|Yes', 'no|No' ], colSpan: 2 },
    { key: 'highest_nursing_status', type: 'select', label: "What's your highest achieved nursing status?", required: true, options: [ 'student|RN Student', 'graduate|(Newly) Graduated Nurse without experience', 'phnurse|Experienced nurse (worked in the Philippines)', 'intlnurse|Experienced nurse (worked abroad)' ], colSpan: 2 },
    { key: 'years_experience', type: 'select', label: "How many years of nursing experience do you have?", required: true, options: [ '0|0', '1|1', '2|2', '3plus|3+'], colSpan: 2 },
    { key: 'living_at', type: 'select', label: "Where are you currently living?", required: true, options: [ 'manila|Metro Manila', 'luzon|Luzon', 'visayas|Visayas', 'mindanao|Mindanao', 'ph|Elsewhere in the Philippines', 'abroad|Abroad' ], colSpan: 2 },
    { key: 'living_abroad', type: 'select', label: "Where Abroad?", required: true, visible: ['living_at=abroad'], options: locationCountries, colSpan: 2, search: true, help: "Search for a country by typing part of the country name." },
    { key: 'first_name', type: 'text', label: "First name", required: true },
    { key: 'last_name', type: 'text', label: "Last name", required: true },
]});

surveyFields.push({ key: 'where', tab: 'questions', type: 'group', label: "Where can we send your job matches?", cols: 1, items: [
    { key: 'email', type: 'email', label: "Email", required: true },
    { key: 'phone', type: 'text', label: "Phone", required: false },
    { key: 'facebook', type: 'text', label: "Facebook", required: false },
]});

export default { surveyConfig, surveyFields };